import {DTO} from '@/shared/base/dto';
import {ENDPOINT, METHOD} from '@/constants';
import {IQueryGetUsage} from '@/types';

export class GetListUsageDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.USAGE;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: IQueryGetUsage;
  constructor(query: IQueryGetUsage) {
    super();
    this.query = query;
  }
}
export class GetListUsageCurentDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.USAGE_CURRENT;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: IQueryGetUsage | undefined;

  constructor(query?: IQueryGetUsage) {
    super();
    this.query = query;
  }
}
export class ExportExcelUsageDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.EXPORT_USAGE;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: IQueryGetUsage;
  constructor(query: IQueryGetUsage) {
    super();
    this.query = query;
    this.responseType = 'blob';
  }
}

export class ExportPdfUsageDTO extends ExportExcelUsageDTO {
  public url = ENDPOINT.EXPORT_PDF_USAGE;
}
